import { useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';
import { useRecoilValue } from 'recoil';
import type { SubjectWithOptionalFee } from 'venn-state';
import { colorIndicesForSubjectsState } from 'venn-state';
import { getColorOnIndex } from 'venn-ui-kit';
import { useHasFF } from 'venn-utils';

export const useSubjectColors = (subjects: SubjectWithOptionalFee[]) => {
  // TODO(VENN-25574): clean up FF when VER-583 is launched
  const hasConsistentColorsFF = useHasFF('studio_consistent_colors_ff');
  const { Colors } = useContext(ThemeContext);

  const subjectColorIndices = useRecoilValue(colorIndicesForSubjectsState(subjects));
  const consistentColors = useMemo(
    () => subjectColorIndices.map((colorIndex) => getColorOnIndex(Colors, colorIndex)),
    [Colors, subjectColorIndices],
  );

  const oldSubjectColors = useMemo(() => subjects.map((_, idx) => getColorOnIndex(Colors, idx)), [Colors, subjects]);

  return hasConsistentColorsFF ? consistentColors : oldSubjectColors;
};
